import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';

const AccionaDropdown = ({
  options,
  label,
  onClick,
  attr,
  selected,
  width,
}) => {
  const intl = useIntl();
  const [active, setActive] = useState('');
  const [block, setBlock] = useState({ display: 'none' });

  const onOpen = () => {
    if (active === 'active') {
      setActive('');
      setBlock({ display: 'none' });
    } else {
      setActive('active');
      setBlock({ display: 'block' });
    }
  };

  return (
    <div
      className="select"
      style={{ width, background: 'white' }}
      onClick={onOpen}
    >
      <div
        style={{ width: width || '300px', height: '48px' }}
        className={'select-styled ' + active}
      >
        {selected[attr] === 'createTemplate'
          ? intl.formatMessage({ id: 'createTemplate' })
          : `${intl.formatMessage({ id: 'template' })}: ${selected[attr]}`}
      </div>
      <ul
        className="select-options select-opt-timezones"
        id="ul-dropdown"
        style={block}
      >
        {options.map((currentValue, index) => (
          <li
            key={`${index}-${currentValue[attr]}`}
            id={`${label}`}
            onClick={() => onClick(currentValue)}
          >
            {currentValue[attr] === 'createTemplate'
              ? intl.formatMessage({ id: 'createTemplate' })
              : `${intl.formatMessage({ id: 'template' })}: ${
                  currentValue[attr]
                }`}
          </li>
        ))}
      </ul>
    </div>
  );
};

AccionaDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  attr: PropTypes.string.isRequired,
  selected: PropTypes.object.isRequired,
  width: PropTypes.string,
};

AccionaDropdown.defaultProps = {
  onClick: () => {},
  width: '300px',
};

export default AccionaDropdown;
